<template>
    <div>
        <h3 class="text-center mb-3">Agregar Asignatura</h3>
        <b-row class="my-3">
            <b-col cols="12">
                <b-button
                    variant="info"
                    class="mx-2"
                    :to="backButtonRoute"
                >
                    <b-icon-arrow-bar-left /> Atrás
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-form @submit.stop.prevent="onSubmit">
                    <b-form-group
                        id="input-group-code"
                        label="*Código:"
                        label-for="input-code"
                    >
                        <b-form-input
                            id="input-code"
                            v-model="$v.form.code.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('code')"
                        />
                        <b-form-invalid-feedback id="input-code-feedback">
                            <ul>
                                <li v-if="!$v.form.code.required">Este campo es requerido.</li>
                                <li v-if="!$v.form.code.numeric">Solo se permiten números positivos.</li>
                                <li v-if="!$v.form.code.isUnique">Ya existe una asignatura con este código.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-name"
                        label="*Nombre:"
                        label-for="input-name"
                    >
                        <b-form-input
                            id="input-name"
                            v-model="$v.form.name.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('name')"
                        />
                        <b-form-invalid-feedback id="input-name-feedback">
                            <ul>
                                <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-careers"
                        label="*Licenciaturas:"
                        label-for="input-careers"
                    >
                        <b-form-tags
                            v-model="$v.form.careers.$model"
                            size="lg"
                            add-on-change
                            no-outer-focus
                            :disabled="formDisabled"
                            :state="validateState('careers')"
                        >
                            <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                                <ul
                                    v-if="tags.length > 0"
                                    class="list-inline d-inline-block mb-2"
                                >
                                    <li
                                        v-for="tag in tags"
                                        :key="tag"
                                        class="list-inline-item"
                                    >
                                        <b-form-tag
                                            @remove="removeTag(tag)"
                                            :title="tag"
                                            :disabled="disabled"
                                            variant="dark"
                                        >
                                            {{ tag }}
                                        </b-form-tag>
                                    </li>
                                </ul>
                                <b-form-select
                                    v-bind="inputAttrs"
                                    v-on="inputHandlers"
                                    :disabled="disabled || availableCareerOptions.length === 0"
                                    :options="availableCareerOptions"
                                >
                                    <template v-slot:first>
                                        <!-- This is required to prevent bugs with Safari -->
                                        <option
                                            disabled
                                            value=""
                                        >Escoja una licenciatura</option>
                                    </template>
                                </b-form-select>
                            </template>
                        </b-form-tags>

                        <b-form-invalid-feedback id="input-careers-feedback">
                            Este campo es requerido.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-credit-units"
                        label="*Unidades de crédito:"
                        label-for="input-credit-units"
                    >
                        <b-form-input
                            id="input-credit-units"
                            v-model="$v.form.creditUnits.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('creditUnits')"
                        />
                        <b-form-invalid-feedback id="input-credit-units-feedback">
                            <ul>
                                <li v-if="!$v.form.creditUnits.required">Este campo es requerido.</li>
                                <li v-if="!$v.form.creditUnits.minValue">Solo se permiten números mayores a 0.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-requirements"
                        label="*Requisitos:"
                        label-for="input-requirements"
                    >
                        <b-form-input
                            id="input-requirements"
                            v-model="$v.form.requirements.$model"
                            type="text"
                            placeholder="Asignatura I, Asignatura II, Asignatura III..."
                            required
                            :disabled="formDisabled"
                            :state="validateState('requirements')"
                        />
                        <b-form-invalid-feedback id="input-requirements-feedback">
                            <ul>
                                <li v-if="!$v.form.requirements.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-type"
                        label="*Tipo:"
                        label-for="input-type"
                    >
                        <b-form-select
                            id="input-type"
                            v-model="$v.form.type.$model"
                            required
                            :options="courseTypeList"
                            :disabled="formDisabled"
                            :state="validateState('type')"
                        />
                        <b-form-invalid-feedback id="input-type-feedback">
                            <ul>
                                <li v-if="!$v.form.type.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-classification"
                        label="*Semestre:"
                        label-for="input-classification"
                        v-if="this.form.type !== 'Otra' && this.form.type !== 'Complementaria'"
                    >
                        <b-form-select
                            id="input-type"
                            v-model="$v.form.classification.$model"
                            required
                            :options="courseClassificationList"
                            :disabled="formDisabled"
                            :state="validateState('classification')"
                        />
                        <b-form-invalid-feedback id="input-classification-feedback">
                            <ul>
                                <li v-if="!$v.form.classification.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="text-center pt-4">
                        <b-button
                            type="submit"
                            variant="primary"
                            size="lg"
                            :disabled="formDisabled || $v.form.$invalid"
                        >
                            Agregar
                        </b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { required, numeric, minValue, requiredUnless } from 'vuelidate/lib/validators'

export default {
    name: 'AdminCoursesCreate',
    data () {
        return {
            formDisabled: false,
            form: {
                code: '',
                name: '',
                careers: [],
                creditUnits: '',
                requirements: '',
                type: 'Obligatoria',
                classification: 'Semestre I'
            }
        }
    },
    validations: {
        form: {
            code: {
                required,
                numeric,
                isUnique: async function (val) {
                    if (val === '') return true
                    try {
                        await this.readCourseByCode(val)
                        return false
                    } catch (err) {
                        if (err.response && err.response.status === 404) {
                            return true
                        } else {
                            this.$root.unknownErrorToast()
                            return false
                        }
                    }
                }
            },
            name: {
                required
            },
            careers: {
                required
            },
            creditUnits: {
                required,
                numeric,
                minValue: minValue(1)
            },
            requirements: {
                required
            },
            type: {
                required
            },
            classification: {
                required: requiredUnless(function () {
                    return this.form.type === 'Complementaria' || this.form.type === 'Otra'
                })
            }
        }
    },
    computed: {
        ...mapState([
            'careerList',
            'courseTypeList',
            'courseClassificationList'
        ]),
        ...mapGetters([
            'isUserAdmin'
        ]),
        availableCareerOptions () {
            return this.careerList.filter(opt => this.form.careers.indexOf(opt) === -1)
        },
        backButtonRoute () {
            if (this.isUserAdmin) {
                return { name: 'admin-courses-list' }
            }

            return { name: 'home' }
        }
    },
    methods: {
        ...mapActions([
            'createCourse',
            'getAllCourses',
            'readCourseByCode'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onSubmit () {
            let loader = null
            const payloadData = JSON.parse(JSON.stringify(this.form))
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.createCourse(payloadData)
                await this.getAllCourses()
                this.$root.successToast(`La asignatura ha sido creada exitosamente.`)
                this.$router.replace({ name: 'admin-courses-list' })
            } catch (err) {
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
